module.exports = __webpack_public_path__ + "img/jbt9158_1_1999.prt.a39edf13.jpg";